import React from 'react';
import { MachineOppgaver } from '~/types';
import ListItem from './ListItem';

export interface ListProps {
  list: MachineOppgaver[]
}

export type ListComponent = React.FC<ListProps>

const List: ListComponent = ({ list }) => {
  return (
    <div>
      {list.map(item => <ListItem key={item.id} item={item} />)}
    </div>
  );

}

export default List
